<template>
  <div class="account-right fixed-mp-cls">
    <orders-bread-crumb></orders-bread-crumb>
    <loader v-show="processInProgress(process)" />
    <div class="account-card schedule-detail">
      <div class="account-header">
        <div class="back-arrow">
          <router-link
            class="d-sm-none"
            :to="{ name: 'profile.ongoing-orders' }"
          >
            <img
              src="/images/svg/global/left_arrow.svg"
              class="img-fluid"
              alt=""
            />
          </router-link>
        </div>
        <h4>{{ _T('My Orders Detail') }}</h4>
      </div>
      <div class="order-title d-sm-none">
        <h6 class="delivered-title">Delivery Order</h6>
      </div>
      <div class="account-body dine-in-details delivery-right">
        <template v-if="selected_order">
          <div class="row">
            <header-left-part
              :store-id="selected_order.store_id"
              :order-type="selected_order.order_type"
              :brand-id="selected_order.brand_id"
            />
            <div class="col-lg-5 pb-3">
              <delivery-ongoing :order="selected_order"></delivery-ongoing>
            </div>
          </div>
          <order-items
            :order-items="selected_order.items"
            :item-modifiers="selected_order.item_modifiers"
            :item-discounts="selected_order.item_discounts"
          />
          <order-price-details v-if="selected_order" :order="selected_order" />
        </template>
        <template v-if="!selected_order && !processInProgress(process)">
          <h5>{{ _T('No Order Found') }}</h5>
        </template>
      </div>
    </div>
    <order-carry-out v-if="selected_order" />
  </div>
</template>

<script>
import OrderItems from './OrderItems'
import DeliveryOngoing from './DeliveryOngoing'
import OrderCarryOut from './OrderCarryOut'
import OrdersBreadCrumb from './OrdersBreadCrumb'
import OrderPriceDetails from './OrderPriceDetails'
import HeaderLeftPart from './Headers/HeaderLeftPart'
import { mapGetters } from 'vuex'
import Loader from '@/components/Elements/Loader.vue'

export default {
  name: 'OrderDetails',
  components: {
    OrderItems,
    DeliveryOngoing,
    OrderCarryOut,
    OrdersBreadCrumb,
    OrderPriceDetails,
    HeaderLeftPart,
    Loader,
  },
  data() {
    return {
      process: 'load-order',
    }
  },
  computed: {
    ...mapGetters(['_T', 'processInProgress', 'selected_order']),
  },
  beforeMount() {
    this.$store.dispatch(
      'startProcess',
      {
        process: this.process,
        progress: true,
      },
      { root: true }
    )
    this.$store
      .dispatch('getOrderById', this.$route.params.order_id)
      .then(() => {})
      .finally(() => {
        this.$store.dispatch('stopProcess', this.process)
      })
  },
}
</script>
<style lang="scss" scoped>
.delivery-right {
  padding: $px40;
  @media (max-width: 575px) {
    padding: $px20;
  }

  .dine-in-table {
    border-top: none;
  }
}

.account-card {
  box-shadow: 0 $px4 $px34 rgba($black, 0.07);
  margin: $px18 0 $px30;
  border-radius: $px10;
  @media (max-width: 575px) {
    margin: 0 !important;
  }
  .order-title {
    .delivered-title {
      @media (max-width: 575px) {
        padding: 10px 0 8px;
        text-align: center;
        margin-bottom: 0;
        background-color: $color-tertiary-1;
        color: $tertiary-color;
      }
    }
  }
  .account-header {
    border-bottom: $px1 solid $dark-border;
    padding: $px16 $px50;
    .back-arrow {
      @media (max-width: 575px) {
        position: absolute;
        top: $px18;
        left: $px20;
        z-index: 1;
      }
    }
    @media (max-width: 575px) {
      display: flex;
      justify-content: space-between;
      align-content: space-between;
    }

    h4 {
      font-weight: 600;
      margin-bottom: 0;
    }
  }
}
</style>
